export default __webpack_public_path__ + "static/media/progressBarStep3.fdd86591.svg";